/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
//import { KTSVG } from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import {LanguageHelp} from '../../../../helpers/LanguageHelper'
import { useAuth } from '../../../../../app/modules/auth'
const SidebarMenuMain = () => {
  const { auth } = useAuth()
  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={LanguageHelp("Dashboard")}
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItemWithSub
        to='/crafted/ai'
        title={LanguageHelp("Artificial Intelligence")}
        icon='/media/icons/duotune/general/gen002.svg'
        fontIcon='bi-ai'
      >
        <SidebarMenuItem to='/apps/artificial-intelligence/overview' title={LanguageHelp('Sentiment Analysis')} hasBullet={true} />
        <SidebarMenuItem to='/apps/artificial-intelligence/restrictions' title={LanguageHelp('Restrictions')} hasBullet={true} />
        <SidebarMenuItem to='/apps/artificial-intelligence/tags' title={LanguageHelp('Tags')} hasBullet={true} />
        <SidebarMenuItem to='/apps/artificial-intelligence/subjectGroups' title={LanguageHelp('Subject Groups')} hasBullet={true} />
        <SidebarMenuItem to='/apps/artificial-intelligence/subjects' title={LanguageHelp('Subjects')} hasBullet={true} />
      </SidebarMenuItemWithSub>
      {(auth?.result.agentRoleList.length == 0 || auth?.result.agentRoleList.includes("Conversation")) &&
        (
          <SidebarMenuItemWithSub
            to='/apps/messaging'
            title={LanguageHelp('Messaging Platform')}
            icon='/media/icons/duotune/communication/com010.svg'
            fontIcon='bi-broadcast'
          >
            <SidebarMenuItem to='/apps/messaging/dashboard' title={LanguageHelp('Analytics')} hasBullet={true} />
            <SidebarMenuItem to='/apps/messaging/templates' title={LanguageHelp('Message Templates')} hasBullet={true} />
            <SidebarMenuItem to='/apps/messaging/campaigns' title={LanguageHelp('Campaigns')} hasBullet={true} />
            <SidebarMenuItem to='/apps/messaging/contacts' title={LanguageHelp('Contacts')} hasBullet={true} />
            <SidebarMenuItem to='/apps/chat/private-chat' title={LanguageHelp('Inbox')} hasBullet={true} />
          </SidebarMenuItemWithSub>
        )
      }

      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title={LanguageHelp("Settings")}
        icon='/media/icons/duotune/coding/cod001.svg'
        fontIcon='bi-person'
      >

        <SidebarMenuItem to='/crafted/account/profile' title={LanguageHelp('Profile')} hasBullet={true} />
        {(auth?.result.agentRoleList.length == 0 || auth?.result.agentRoleList.includes("Setting")) &&
          (
            <div>
              <SidebarMenuItem to='/crafted/account/company' title={LanguageHelp('Company')} hasBullet={true} />
              <SidebarMenuItem to='/crafted/chatbot-settings' title={LanguageHelp('Chatbot')} hasBullet={true} />
              <SidebarMenuItem to='/crafted/channels' title={LanguageHelp('Channels')} hasBullet={true} />
              <SidebarMenuItem to='/apps/user-management/users' title={LanguageHelp('User Management')} hasBullet={true} />
            </div>
          )
        }

      </SidebarMenuItemWithSub>
    </>
  )
}

export { SidebarMenuMain }
